import FilterParameterDto from "../datasourcemodule/FilterParameterDto";
import DataTableFieldParameterDefinitionDto from "../datasourcemodule/DataTableFieldParameterDefinitionDto";

class PathSynchroMappingDto {
    IsKey: boolean;
    SourceFieldReferenceId: number;
    TargetFieldReferenceId: number;
    TransformationLogicId: number;
    TransformationParameters: string;
    Filters: FilterParameterDto[];
    DeclaredVariables: DataTableFieldParameterDefinitionDto[];

    constructor(
        isKey: boolean,
        sourceFieldReferenceId: number,
        targetFieldReferenceId: number,
        transformationLogicId: number,
        transformationParameters: string,
        filters: FilterParameterDto[],
        declaredVariables: DataTableFieldParameterDefinitionDto[] = []
    ) {
        this.IsKey = isKey;
        this.SourceFieldReferenceId = sourceFieldReferenceId;
        this.TargetFieldReferenceId = targetFieldReferenceId;
        this.TransformationLogicId = transformationLogicId;
        this.TransformationParameters = transformationParameters;
        this.Filters = filters;
        this.DeclaredVariables = declaredVariables;
    }
}

export default PathSynchroMappingDto;
